"use client";

import { Pencil, Trophy, Gift, Calculator } from "lucide-react";
// import FloatingElements from "./_components/FloatingElements";
import Profile from "./_components/Profile";
import { useNavigate } from "react-router-dom";

const KidsLearningApp = () => {
  const router = useNavigate();

  const handleStartPractice = () => {
    router("/word-prompt");
  };

  const mainButtons = [
    {
      id: 1,
      title: "Word Practice",
      icon: <Pencil className="w-10 h-10" />,
      color: "from-purple-400 via-pink-400 to-purple-600",
      hoverColor: "from-purple-500 via-pink-500 to-purple-700",
      onclick: handleStartPractice,
    },
    {
      id: 2,
      title: "Fun with Numbers",
      icon: <Calculator className="w-10 h-10" />,
      color: "from-orange-400 via-yellow-400 to-red-500",
      hoverColor: "from-orange-500 via-yellow-500 to-red-600",
      onclick: () => router("/fun-with-numbers"),
    },
    {
      id: 3,
      title: "Leaderboard",
      icon: <Trophy className="w-10 h-10" />,
      color: "from-blue-400 via-cyan-400 to-teal-500",
      hoverColor: "from-blue-500 via-cyan-500 to-teal-600",
      onclick: () => router("/leaderboard"),
    },
    {
      id: 4,
      title: "My Collectibles",
      icon: <Gift className="w-10 h-10" />,
      color: "from-green-400 via-emerald-400 to-blue-500",
      hoverColor: "from-green-500 via-emerald-500 to-blue-600",
      onclick: () => router("/collectables"),
    },
  ];

  return (
    <div className="h-screen bg-gradient-to-br from-pink-200 via-purple-200 to-indigo-200 p-4 flex flex-col overflow-hidden">
      <div className="max-w-4xl mx-auto w-full flex flex-col flex-1 min-h-0">
        {/* Header Section */}
        <Profile />
        {/* Main Action Buttons */}
        <div className="grid grid-cols-2 gap-4 flex-1 min-h-0">
          {mainButtons.map((button) => (
            <button
              key={button.id}
              onClick={button.onclick}
              className={`group relative bg-gradient-to-r ${
                button.color
              } hover:${
                button.hoverColor
              } text-white rounded-3xl p-6 shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 ${
                button.onclick ? "overflow-hidden" : "overflow-visible"
              } border-4 border-white/30 ${
                button.onclick
                  ? "cursor-pointer"
                  : "cursor-not-allowed opacity-60"
              }`}
            >
              {!button.onclick && (
                <div className="absolute -top-4 -right-4 bg-yellow-400 text-purple-800 px-3 py-1 rounded-full text-sm font-bold shadow-lg border-2 border-white z-10">
                  Coming Soon
                </div>
              )}
              <div className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative flex flex-col items-center gap-4 text-center">
                <div className="flex items-center gap-3">
                  <div className="group-hover:rotate-12 group-hover:scale-125 transition-transform duration-300">
                    {button.icon}
                  </div>
                </div>
                <span className="text-2xl font-bold group-hover:scale-105 transition-transform duration-300">
                  {button.title}
                </span>
              </div>
              <div className="absolute -right-8 -top-8 w-24 h-24 bg-white/10 rounded-full group-hover:scale-150 transition-transform duration-500"></div>
              <div className="absolute -left-4 -bottom-4 w-16 h-16 bg-white/10 rounded-full group-hover:scale-125 transition-transform duration-700"></div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KidsLearningApp;
